import React from "react";

const GridCell = ({ children, className }) => {
    return <div className={`Grid-cell ${className ? className : ""}`}>{children}</div>;
};
export default GridCell;
